import { isPlainObject, patchSessionMainRunInCache } from './patchSessionMainRunInCache'

/**
 * Two-level merge: shallow-merges `settingsPatch` into cached
 * `attributes.mainRun.settings` for the matching session row, preserving
 * sibling keys both at `mainRun` and at `mainRun.settings`. Does not refetch.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {{ sessionId: string|number, settingsPatch: Record<string, unknown> }} params
 */
export function patchSessionSettingsInLibraryCache(queryClient, { sessionId, settingsPatch } = {}) {
  if (!isPlainObject(settingsPatch) || Object.keys(settingsPatch).length === 0) {
    return
  }

  patchSessionMainRunInCache(queryClient, {
    sessionId,
    transform: (prevMainRun) => {
      const prevSettings = isPlainObject(prevMainRun.settings) ? prevMainRun.settings : {}
      return {
        ...prevMainRun,
        settings: { ...prevSettings, ...settingsPatch },
      }
    },
  })
}
